export default __webpack_public_path__ + "static/media/delivery_wpp_web.b7846a69.png";